import { render } from "./LoginModal.vue?vue&type=template&id=6edbcdce"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"
script.render = render

export default script